import { useEffect } from 'react';

import { useRouter } from 'expo-router';

/**
 * Drops `unavailableItemId` from the section URL once the store menu confirms
 * the item is orderable (e.g. after changing restaurants).
 */
export function useClearUnavailableItemIdWhenAvailable({
  unavailableItemId,
  isStoreMenuReady,
  isAvailableAtStore,
}: {
  unavailableItemId?: string;
  isStoreMenuReady: boolean;
  isAvailableAtStore: boolean;
}): void {
  const router = useRouter();

  useEffect(() => {
    if (!unavailableItemId || !isStoreMenuReady || !isAvailableAtStore) {
      return;
    }
    router.setParams({ unavailableItemId: '' });
  }, [unavailableItemId, isStoreMenuReady, isAvailableAtStore, router]);
}
